<span>
    Gracias por tu mensaje, me pondré en contacto pronto contigo. 🎉🎊
</span>